import React from "react";

const ROW_CONTAINER_CLASS = "flex w-full m-1";
const LABEL_TEXT_CLASS = "w-80 body2 text-slate-700";

interface SessionNoteRowProps {
  label: string;
  children: React.ReactNode;
}

const SessionNoteRow: React.FC<SessionNoteRowProps> = ({ label, children }) => (
  <div className={ROW_CONTAINER_CLASS}>
    <div className={LABEL_TEXT_CLASS}>{label}</div>
    {children}
  </div>
);

export default SessionNoteRow;
